import React, { useState, useEffect } from "react";
import { FaEye } from "react-icons/fa";
import axios from "axios";
import KeypadModal from "../models/KeypadModal";
import ConfirmModal from "../models/ConfirmModal";
import EyeIconBigPopup from "../models/EyeIconBigPopup";
import BASE_URL from "../utils/Urls";

export default function BottomEyeIcon({
  onClose,
  todayBankedEarningsCount = 0,
  todayPaidEarningsCount = 0,
  todayPaymentDueCount = 0,
  dataVersion = 0,
}) {
  const [showKeyPad, setShowKeypad] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showEyeIconBigPopup, setShowEyeIconBigPopup] = useState(false);

  useEffect(() => {
    const fetchLock = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/locks/`);
        console.log("🔐 Lock fetched:", res.data.lock);
      } catch (err) {
        console.error("❌ Failed to fetch lock:", err);
      }
    };
    fetchLock();
  }, []);

  return (
    <>
      {showEyeIconBigPopup && (
        <EyeIconBigPopup
          refreshKey={dataVersion}
          user={{
            todayBankedEarningsCount,
            todayPaidEarningsCount,
            todayPaymentDueCount,
          }}
          onClose={() => {
            console.log("👁️ Closing EyeIconBigPopup");
            setShowEyeIconBigPopup(false);
            onClose?.();
          }}
        />
      )}

      <div className="relative h-20 mt-10">
        {!showKeyPad && !showEyeIconBigPopup && !showConfirm && (
          <div
            onClick={() => {
              console.log("👁️ Eye button clicked — showing keypad");
              setShowKeypad(true);
            }}
            className="absolute bottom-0 right-0 w-[100px] h-[110px] border-2 border-[#FF0000] bg-white flex flex-col items-center justify-center rounded-lg cursor-pointer"
          >
            <FaEye className="text-6xl text-[#FF0000]" />
            <p className="text-3xl font-bold text-[#FF0000]">Total</p>
          </div>
        )}

        {showKeyPad && (
          <KeypadModal
            type="primary" 
            onGoClick={() => {
              console.log("✅ primary lock verified — showing confirm modal");
              setShowConfirm(true);
              setShowKeypad(false);
            }}
            onClose={() => {
              console.log("❌ Keypad closed");
              setShowKeypad(false);
            }}
          />
        )}

        {showConfirm && (
          <ConfirmModal
            onYes={() => {
              console.log("✅ Confirmed — opening EyeIconBigPopup");
              setShowConfirm(false);
              setShowEyeIconBigPopup(true);
            }}
            onNo={() => {
              console.log("❌ Confirmation canceled");
              setShowConfirm(false);
            }}
          />
        )}
      </div>
    </>
  );
}
